import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { ReservedEnrollmentsRedux } from '../Redux/ReservedEnrollmentsRedux'

const reservedEnrollmentsCrudObservable = createCRUDObservable({
  mainRedux: ReservedEnrollmentsRedux,
  reduxPath: 'reserved_enrollments',
  dataHandlers: {
    get: response => response.data,
  },
})

export const reservedEnrollmentsObservers = Object.assign({}, reservedEnrollmentsCrudObservable.observers, {})

export const reservedEnrollmentsEpic = combineEpics(
  reservedEnrollmentsCrudObservable.epic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/ReservedEnrollmentsObservable.js